import { Handshake, Repeat, ShieldCheck, Rocket } from '@phosphor-icons/react';
import { Box, Card, CardContent, Container, Stack, Typography } from '@mui/material';
import { SectionEyebrow, interactiveCardSx } from '@scoutingops/ui';

const pillars = [
  {
    icon: Repeat,
    title: 'Leadership changes. Your site doesn\u2019t.',
    description: 'Volunteers rotate every year or two. Scouting Ops Site stays. New leaders pick up right where the last ones left off \u2014 no rebuilds, no lost content.',
  },
  {
    icon: Rocket,
    title: 'Found online in seconds',
    description: 'When a family searches for a local youth program, your unit shows up with a polished, professional site \u2014 not a dead link or a locked Facebook group.',
  },
  {
    icon: ShieldCheck,
    title: 'Built for youth programs',
    description: 'No exposed emails, no youth data fields, no guesswork. Every template follows youth program communication guidelines out of the box.',
  },
  {
    icon: Handshake,
    title: 'Anyone can manage it',
    description: 'No web developers needed. No IT committee. If a leader can send a text message, they can keep your unit\u2019s site current.',
  },
];

export default function ProblemSection() {
  return (
    <Box component="section" sx={{ py: { xs: 10, md: 14 }, bgcolor: 'action.hover' }}>
      <Container maxWidth="lg">
        <Stack spacing={1.5} sx={{ alignItems: 'center', textAlign: 'center', mb: 7 }}>
          <SectionEyebrow>A Digital Foundation</SectionEyebrow>
          <Typography variant="h3" sx={{ fontWeight: 800, maxWidth: 760 }}>
            Parents come and go. Your unit&apos;s online presence shouldn&apos;t.
          </Typography>
          <Typography color="text.secondary" sx={{ maxWidth: 760, fontSize: { xs: '1rem', md: '1.1rem' } }}>
            Every unit needs a digital home that outlasts any single volunteer.
            Scouting Ops Site gives you a foundation that&apos;s always on, always current, and always ready for the next family walking through the door.
          </Typography>
        </Stack>

        <Box
          sx={{
            display: 'grid',
            gap: 2,
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(2,minmax(0,1fr))', lg: 'repeat(4,minmax(0,1fr))' },
          }}
        >
          {pillars.map((pillar) => (
            <Card key={pillar.title} variant="outlined" sx={[{ borderColor: 'divider', boxShadow: 0, height: '100%' }, interactiveCardSx]}>
              <CardContent sx={{ p: 3 }}>
                <Box
                  className="brand-cardIcon"
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: 2,
                    display: 'grid',
                    placeItems: 'center',
                    bgcolor: 'action.hover',
                    color: 'primary.main',
                    mb: 2,
                  }}
                >
                  <pillar.icon size={18} />
                </Box>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>{pillar.title}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>{pillar.description}</Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
